export class AssignmentsHistoryEntry {
    user: string;
    date: Date;
    changes: { [key: string]: any; } = {};

    constructor(user: string, date: Date, changes: { [key: string]: any; }) {
        this.user = user;
        this.date = date;
        this.changes = changes;
    }
}
